/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { NameserverReadWithZones } from "../../models/nameserver-read-with-zones";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadNameserver$Params {
  organisation_id: string;
  nameserver_id: number;
}

export function readNameserver(
  http: HttpClient,
  rootUrl: string,
  params: ReadNameserver$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<NameserverReadWithZones>> {
  const rb = new RequestBuilder(rootUrl, readNameserver.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("nameserver_id", params.nameserver_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NameserverReadWithZones>;
    }),
  );
}

readNameserver.PATH = "/surfdomeinen/organisations/{organisation_id}/nameservers/{nameserver_id}";
